'use client';
import { Grid, Stack } from '@mui/material';
import Optional from '../../../Optional';
import { TBLinkType } from '../../../../utils/mappers/link';
import RichText, { RichTextContent } from '../../../RichText';
import { HeroType } from '../type';
import RichCtaButton from '../../../elements/RichCtaButton';

type Props = {
  title?: RichTextContent;
  subtitle?: RichTextContent;
  cta?: TBLinkType;
  cta2?: TBLinkType;
  hAlignment?: HeroType['hAlignment'];
  fullWidth?: boolean;
};

const textAlignMap = {
  start: 'left',
  center: 'center',
  end: 'right',
} as const;

const Titles = ({
  cta,
  cta2,
  title,
  subtitle,
  hAlignment,
  fullWidth,
}: Props) => {
  const textAlign = hAlignment ? textAlignMap[hAlignment] : 'inherit';
  const isCenter = hAlignment === 'center';
  const width = fullWidth ? '100%' : isCenter ? '80%' : '60%';
  return (
    <Stack
      spacing={5}
      sx={{
        width: '100%',
        alignItems: hAlignment,
      }}
    >
      <Stack
        spacing={3}
        sx={{
          width: '100%',
          alignItems: hAlignment,
        }}
      >
        <RichText
          withTypography
          color={'textPrimary'}
          variant="h1"
          sx={{
            maxWidth: { xs: '100%', md: width },
            textAlign,
          }}
        >
          {title}
        </RichText>
        <RichText
          withTypography
          color={'textPrimary'}
          variant="h5"
          component={'p'}
          sx={{ maxWidth: { xs: '100%', md: width, textAlign } }}
        >
          {subtitle}
        </RichText>
      </Stack>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, md: 'auto' }}>
          <Optional condition={!!cta}>
            <RichCtaButton cta={cta} track={{ position: 'hero' }} />
          </Optional>
        </Grid>
        <Optional condition={!!cta2}>
          <Grid size={{ xs: 12, md: 'grow' }}>
            <RichCtaButton cta={cta2} track={{ position: 'hero' }}>
              {cta2?.label}
            </RichCtaButton>
          </Grid>
        </Optional>
      </Grid>
    </Stack>
  );
};

export default Titles;
